// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mTl3","col":"styles_col__1zMhJ","actions":"styles_actions__3xSm7","conflict":"styles_conflict__2MMji"};